var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 36,
    viewBox: "0 0 25 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M19.053 5.644c0 1.16-.94 2.101-2.101 2.101s-2.102-.94-2.102-2.101.94-2.102 2.102-2.102c1.16 0 2.101.94 2.101 2.102M12.35 2.477c0 1.368-1.109 2.477-2.477 2.477-1.368 0-2.477-1.11-2.477-2.477C7.396 1.109 8.506 0 9.873 0c1.368 0 2.477 1.109 2.477 2.477M22.48 10.021c0 .616-.499 1.115-1.113 1.115-.616 0-1.115-.5-1.115-1.115 0-.614.499-1.114 1.115-1.114.614 0 1.113.5 1.113 1.114",
    transform: "translate(.715 .158)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M23.543 13.108c0-.314-.254-.567-.566-.567h-2.158c-.313 0-.566.253-.566.567 0 .292.222.53.505.56v3.79l-6.453 3.71v-3.757L7.77 21.17V17.41L0 21.881v11.232c0 1.013.82 1.834 1.834 1.834H23.036V13.668c.285-.03.507-.268.507-.56zM9.185 28.37c0 .373-.303.676-.676.676H5.62c-.373 0-.676-.303-.676-.676v-2.888c0-.374.303-.676.676-.676H8.51c.373 0 .676.302.676.676v2.888zm9.098 0c0 .373-.302.676-.675.676H14.72c-.373 0-.676-.303-.676-.676v-2.888c0-.374.303-.676.676-.676h2.888c.373 0 .675.302.675.676v2.888z",
    transform: "translate(.715 .158)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.f53dfc195c428473574eb6382795b760.svg";
export { ForwardRef as ReactComponent };